'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    min-width: ', ';\n'], ['\n    min-width: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _alignments = require('../../../../constants/alignments');

var _colors = require('../../../../constants/colors');

var _sizes = require('../../../../constants/sizes');

var _chat = require('../../../../atoms/icons/chat');

var _chat2 = _interopRequireDefault(_chat);

var _call = require('../../../../atoms/icons/call');

var _call2 = _interopRequireDefault(_call);

var _iconButton = require('../../../../atoms/buttons/iconButton');

var _iconButton2 = _interopRequireDefault(_iconButton);

var _link = require('../../../../atoms/link');

var _link2 = _interopRequireDefault(_link);

var _container = require('../../../../layouts/container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HelpCTA = (0, _styledComponents2.default)(_iconButton2.default)(_templateObject, function (_ref) {
    var isMobile = _ref.isMobile;
    return isMobile ? '100%' : '220px';
});

var ContactInfo = function (_React$Component) {
    _inherits(ContactInfo, _React$Component);

    function ContactInfo(props) {
        _classCallCheck(this, ContactInfo);

        var _this = _possibleConstructorReturn(this, (ContactInfo.__proto__ || Object.getPrototypeOf(ContactInfo)).call(this, props));

        _this.state = {
            callHover: false,
            chatHover: false,
            smsHover: false
        };
        return _this;
    }

    _createClass(ContactInfo, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var callComponent = "";
            var smsComponent = "";
            var calenderlyComponent = "";
            var chatComponent = "";

            if (this.props.context.configuration.telephone) {
                callComponent = _react2.default.createElement(
                    _container2.default,
                    { fullWidth: this.context.screen.isMobile,
                        mouseEnterEvent: function mouseEnterEvent() {
                            return _this2.setState({ callHover: true });
                        },
                        mouseLeaveEvent: function mouseLeaveEvent() {
                            return _this2.setState({ callHover: false });
                        },
                        bottom: this.context.screen.isMobile && _sizes.Sizes.xs
                    },
                    _react2.default.createElement(HelpCTA, {
                        isMobile: this.context.screen.isMobile,
                        right: !this.context.screen.isMobile && _sizes.Sizes.sm,
                        text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: this.props.context.configuration.telephoneText || this.props.callText }),
                        icon: _react2.default.createElement(_call2.default, { primary: this.state.callHover ? _colors.Colors.Secondary : _colors.Colors.Primary }),
                        iconPosition: this.props.iconPosition,
                        clickEvent: function clickEvent() {
                            return window.location = 'tel:' + _this2.props.context.configuration.telephone;
                        }
                    })
                );
            }

            if (this.props.context.configuration.sms) {
                smsComponent = _react2.default.createElement(
                    _container2.default,
                    { fullWidth: this.context.screen.isMobile,
                        mouseEnterEvent: function mouseEnterEvent() {
                            return _this2.setState({ smsHover: true });
                        },
                        mouseLeaveEvent: function mouseLeaveEvent() {
                            return _this2.setState({ smsHover: false });
                        }
                    },
                    _react2.default.createElement(HelpCTA, {
                        isMobile: this.context.screen.isMobile,
                        text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: this.props.context.configuration.smsText || this.props.smsText }),
                        clickEvent: function clickEvent() {
                            return document.location.href = 'sms:' + _this2.props.context.configuration.sms + '&body=Hi%2C%20I%20would%20prefer%20to%20use%20SMS%20text%20to%20lock%20in%20my%20price';
                        },
                        iconPosition: this.props.iconPosition,
                        icon: _react2.default.createElement(_chat2.default, { primary: this.state.smsHover ? _colors.Colors.Secondary : _colors.Colors.Primary })
                    })
                );
            }

            if (this.props.context.configuration.scheduler) {
                calenderlyComponent = _react2.default.createElement(
                    _container2.default,
                    null,
                    _react2.default.createElement(_link2.default, {
                        text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: this.props.context.configuration.schedulerText || this.props.callSetUpText }),
                        textAlign: _alignments.Alignments.left,
                        top: _sizes.Sizes.md,
                        right: !this.context.screen.isMobile && _sizes.Sizes.md,
                        size: _sizes.Sizes.md,
                        clickEvent: function clickEvent() {
                            window.Calendly.showPopupWidget('https://calendly.com/' + _this2.props.context.configuration.scheduler);
                        }
                    })
                );
            }

            if (this.props.chatText || this.props.context.configuration.chatText) {
                chatComponent = _react2.default.createElement(
                    _container2.default,
                    null,
                    _react2.default.createElement(_link2.default, {
                        text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: this.props.context.configuration.chatText || this.props.chatText }),
                        textAlign: _alignments.Alignments.left,
                        top: _sizes.Sizes.md,
                        size: _sizes.Sizes.md,
                        clickEvent: function clickEvent() {
                            eval("olark('api.box.expand');");
                        }
                    })
                );
            }

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    _container2.default,
                    { inline: !this.context.screen.isMobile, horizontalAlignment: _alignments.Alignments.left, verticalAlignment: _alignments.Alignments.top, top: _sizes.Sizes.xs },
                    callComponent,
                    smsComponent
                ),
                _react2.default.createElement(
                    _container2.default,
                    { inline: !this.context.screen.isMobile },
                    calenderlyComponent,
                    chatComponent
                )
            );
        }
    }]);

    return ContactInfo;
}(_react2.default.Component);

ContactInfo.contextTypes = {
    screen: _propTypes2.default.object
};

exports.default = ContactInfo;